export default __webpack_public_path__ + "static/media/loading.b75b820d.gif";